<template>
    <v-dialog :modelValue="dialog" @click:outside="$emit('updateDialog')" @keydown.esc="$emit('updateDialog')" width="750">
        <v-card>
            <v-card-title class="title-modal">
                <span class="headline">Confirmar Expedir orden de envío #{{ shipment_order?.code }}</span>
            </v-card-title>

            <v-card-text>
                <p>
                    ¿Esta seguro que desea expedir manualmente la orden de envío <b>#{{ shipment_order?.code }}</b>?
                </p>
                <p>
                    Los siguientes LPNs quedaran expedidos junto con la orden de envio.
                </p>
                <div>
                    <b>
                    <span v-for="(lpn) in lpns_to_ship" :key="lpn.id" style="margin-right: 10px;">
                        <v-chip                        
                        size="small"
                        color="black"
                        variant="outlined"
                        class="mt-2"
                        >
                        {{ lpn.lpn.code }}
                        </v-chip>
                    </span>
                    </b>
                    
                </div>
                <div v-if="lpns_to_unship && lpns_to_unship.length > 0">
                    <hr />
                        <v-radio-group
                            v-model="create_partial"
                            density="compact"
                            hide-details
                        >
                            <v-radio :value="false">
                                <template #label>
                                    <div class="ml-3">
                                        <div>Desasociar del envío</div>
                                        <div class="text-caption text-medium-emphasis">
                                            Los LPNs vuelven a quedar disponibles para almacenarse nuevamente.
                                        </div>
                                    </div>
                                </template>
                            </v-radio>
                            <v-radio :value="true">
                                <template #label>
                                    <div class="ml-3">
                                        <div>Pasar a un pedido hijo</div>
                                        <div class="text-caption text-medium-emphasis">
                                            Se genera una nueva orden de envío con los LPNs restantes, ya en estado empaquetado y lista para expedir más adelante.
                                        </div>
                                    </div>
                                </template>
                            </v-radio>
                        </v-radio-group>
                    <hr />
                    <p style="color:red">
                        <span v-if="create_partial">Los siguientes LPNs quedaran en un nuevo pedido de expedición (Empaquetado), vinculado a esta orden de envío.</span>
                        <span v-else>Los siguientes LPNs quedaran desasociados de la orden de envio y podrá almacenarlos nuevamente.</span>
                    </p>
                </div>
                <div>
                    <b>
                    <span v-for="(lpn) in lpns_to_unship" :key="lpn.id" style="margin-right: 10px;">
                        <v-chip
                        size="small"
                        color="red"

                        class="mt-2"
                        >
                        {{ lpn.lpn.code }}
                        </v-chip>
                    </span>
                    </b>
                </div>

            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn color="red darken-1" text @click="closeModal()"> No </v-btn>

                <v-btn color="green darken-1" text @click="expedir()" :loading="loading"> Si </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { lpnService } from "@/libs/ws/lpnService";
import { shipmentOrderService } from "@/libs/ws/shipmentOrderService";
import ValidMixin from "@/mixins/ValidMixin.vue";

export default {
    created() { },
    mixins: [ValidMixin],
    components: {},
    props: {
        dialog: Boolean,
        updateDialog: Function,
        shipment_order: Object,
        lpns_to_ship: Array,
        lpns_to_unship: Array,
        shipedSuccess: Function,
    },
    data: () => ({
        lpns: [],
        almacenes: [],
        loading: false,
        create_partial: false,
    }),
    mounted() {

    },
    methods: {
        closeModal() {
            this.lpns = [];
            this.create_partial = false;
            this.$emit("updateDialog");
        },
        expedir() {
            let params = {
                shipment_order_ids: [this.shipment_order.id],
                lpn_codes: this.lpns_to_ship.map(lpn_item => lpn_item.lpn.code),
                create_partial_order_with_remaining: this.create_partial,
            };

            this.loading = true;
            shipmentOrderService
                .shiped(params)
                .then((response) => {
                    if(response.status){
                        this.toast.success(response.msg);
                        this.create_partial = false;
                        this.$emit("updateDialog");
                        this.$emit("shipedSuccess");
                    } else {
                        this.toast.error(response.msg || "Error al expedir la orden de envío");
                    }
                })
                .catch((e) => {
                    this.toast.error(e.msg || "Error al expedir la orden de envío");
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
};
</script>